export default "__VITE_ASSET__BSArzNB9__"